
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NewsPage from '../pages/news/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/news/:id',
    element: <NewsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
